import $ from 'jquery';

export default function popupSection() {
	const POPUP = $('.popup');

	if (POPUP.length) {
		const close = POPUP.find('.popup_close');

		close.click(() => {
			POPUP.addClass('+hidden');
		});

		if (!sessionStorage.getItem('shownPopup')) {
			setTimeout(()=>{
				POPUP.removeClass('+hidden');
			}, 1000);

			sessionStorage.setItem('shownPopup', 'yes');
		}
	}
}



// WEBPACK FOOTER //
// ./source/scripts/section/popup.js